import { render, staticRenderFns } from "./SubscriptionAnnounce.vue?vue&type=template&id=2dc29e5e&scoped=true&"
import script from "./SubscriptionAnnounce.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionAnnounce.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionAnnounce.vue?vue&type=style&index=0&id=2dc29e5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc29e5e",
  null
  
)

export default component.exports